import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { APIConstants } from "../../constants/ApiConstants";
import { constant } from "../../constants";
import { useNavigate } from "react-router-dom";
import { getModulePermissions } from "../../util/permissions";
import { useDispatch } from "react-redux";
import { loginCognitoActions } from "../../redux/slices/loginSlice";
import { resetPasswordEmailActions } from "../../redux/slices/resetPasswordEmailSlice";
import { merchantActions } from "../../redux/slices/merchantSlice";
import { getUserFromURL } from "../../components/forms/utility";
import { sideMenuList } from "../../static-models/sidemenu";
import { useAppSelector } from "../../redux/hooks";
import { selectFeaturePermissions } from "../../redux/selectors/loginSelector";
import { NormalTextToSnakeCase } from "../../components/AccessManagement/utils";
import { startSession } from "../../services/interceptors/ApiInterceptor";
// import { getGCaptchaToken } from "../../services/ApiServices/GetCaptcha";
const useFetchLogin = (email: string, password: string, adminRole: string) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const data = useAppSelector(selectFeaturePermissions);

  const item = localStorage.getItem("isFromRedirect");
  const isFromRedirect = item ? JSON.parse(item) : null;


  useEffect(() => {
  
    if (data && isFromRedirect) {
      navigate("/redirect");
    } else if (data && !isFromRedirect) {
      navigate(navigateModule);
    }

    // if (data) navigate(navigateModule);
    // if (data)
  }, [data]);
  const finalPermission = data && Object.keys(data);
  const firstElement = sideMenuList?.filter((menu) =>
    finalPermission?.includes(NormalTextToSnakeCase(menu?.module))
  );
  const navigateModule = firstElement.length ? firstElement[0]?.path : "/";

  const userTypeFromUrl = useMemo(() => getUserFromURL(), []);

  const handleLogin = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.login,
        {
          email,
          password,
          user_type: userTypeFromUrl,
        }
      );
      const data = response.data.data;
      if (data.IdToken) {
        setLoading(false);

        const resData = {
          jwtToken: data.IdToken,
          groups: JSON.stringify(data.tokenData["cognito:groups"]),
          userTypeGroup:
            data.tokenData && Array.isArray(data.tokenData["cognito:groups"])
              ? data.tokenData["cognito:groups"][0]
              : null,
          username: data.tokenData["cognito:username"],
          email: data.tokenData.email,
          sub: data.tokenData.sub,
          accessToken: data.AccessToken,
          permissions: response?.data?.permissions
            ? JSON.parse(response?.data?.permissions[0]?.permissions ?? "[]")
            : [],
          featurePermissions: response?.data?.permissions
            ? JSON.parse(response?.data?.permissions[0]?.permissions_v2 ?? "{}")
            : {},
          userRole: response.data.user ? response.data.user.user_role : "",
          firstName: response.data.user ? response.data.user.firstName : "",
          lastName: response.data.user ? response.data.user.lastName : "",
          department: response.data.user ? response.data.user.department : "",
        };

        if (
          (constant.domain === process.env.REACT_APP_ADMIN_DOMAIN ||
            constant.domain === process.env.REACT_APP_CSA_DOMAIN) &&
          JSON.stringify(data.tokenData["cognito:groups"]).includes(
            constant.merchant
          )
        ) {
          setError("Not authorized to use this portal");
          setSuccess(false);
        } else if (
          constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN &&
          JSON.stringify(data.tokenData["cognito:groups"]).includes(
            constant.adminRole
          )
        ) {
          setError("Not authorized to use this portal");
          setSuccess(false);
        } else if (
          constant.domain === process.env.REACT_APP_CSA_DOMAIN &&
          JSON.stringify(data.tokenData["cognito:groups"]).includes(
            constant.adminRole
          ) &&
          !(
            getModulePermissions(resData.permissions, constant.modules.sales) ||
            getModulePermissions(
              resData.permissions,
              constant.modules.memberRedemption
            )
          )
        ) {
          setError("Not authorized to use this portal");
          setSuccess(false);
        }

        dispatch(loginCognitoActions.loginCognitoInfo(resData));

        localStorage.setItem(
          "groups",
          JSON.stringify(data.tokenData["cognito:groups"])
        );

        localStorage.setItem("jwtToken", data.IdToken);
        localStorage.setItem("email", data.IdToken);
        localStorage.setItem("firstName", data.IdToken);
        localStorage.setItem("department", data.IdToken);
        localStorage.setItem("lastName", data.IdToken);
        localStorage.setItem("accessToken", data.AccessToken);
        localStorage.setItem("username", data.tokenData.email);
        localStorage.setItem("refreshToken", data.RefreshToken);
        localStorage.setItem("expiresIn", data.ExpiresIn);
        startSession();
        if (
          Array.isArray(data.tokenData["cognito:groups"]) &&
          data.tokenData["cognito:groups"].includes("merchant") &&
          constant.domain === process.env.REACT_APP_MERCHANT_DOMAIN &&
          !(resData.userRole && resData.userRole === "Tenant Physical Voucher")
        ) {
          dispatch(
            merchantActions.updateLoginMerchantList({
              loginMerchantsList: response.data.merchants,
            })
          );
          const merchant =
            response?.data?.merchants[0]?.response?.stores.store[0];
          const companyNameField = merchant.custom_fields.field.find(
            (field: any) => {
              return field.name === "companyName";
            }
          );
          const merchantLogoField = merchant.custom_fields.field.find(
            (field: any) => {
              return field.name === "merchant_image";
            }
          );
          dispatch(
            merchantActions.updateSelectedMerchantDetails({
              selectedMerchatDetails: {
                merchantName: merchant?.name,
                merchantId: merchant.id,
                external_id: merchant.external_id,
                storeCode: merchant.code,
                companyName: companyNameField?.value,
                merchant_logo: merchantLogoField?.value,
              },
            })
          );

          localStorage.setItem(
            "loginName",
            `${response.data.user.firstName} ${response.data.user.lastName}`
          );

          // navigate(navigateModule);
          return;
        }
        if (
          Array.isArray(data.tokenData["cognito:groups"]) &&
          data.tokenData["cognito:groups"].includes("admin") &&
          constant.domain === process.env.REACT_APP_ADMIN_DOMAIN &&
          !(
            resData.userRole === "Digital CSA" ||
            resData.userRole === "Digital CSO" ||
            resData.userRole === "Digital CSM"
          )
        ) {
          // navigate(navigateModule);
          return;
        }
        if (
          Array.isArray(data.tokenData["cognito:groups"]) &&
          data.tokenData["cognito:groups"].includes("admin") &&
          constant.domain === process.env.REACT_APP_CSA_DOMAIN &&
          (resData.userRole !== "Super Admin" ||
            resData.userRole === "Digital CSA" ||
            resData.userRole === "Digital CSO" ||
            resData.userRole === "Digital CSM")
        ) {
          // navigate(navigateModule);
          return;
        } else {
          setError("Not authorized to use this portal");
          setTimeout(() => {
            setError("");
          }, 4000);
        }
      }
    } catch (err: any) {
      setError(err?.response?.data?.message);
      setSuccess(false);
      setLoading(false);
      setTimeout(() => {
        setError("");
      }, 4000);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPasswordClick = async () => {
    // const result = await getGCaptchaToken();
   

    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.forgotPassword,
        {
          email,
          type: "forgot-password",
          user_type: userTypeFromUrl,
        }
      );

      // const response = await axios.post(
      //   process.env.REACT_APP_API_URL_PHASE_2 +
      //     "v2/" +
      //     APIConstants.forgotPassword,
      //   {
      //     email,
      //     type: "forgot-password",
      //     user_type: userTypeFromUrl,
      //   },
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //       "X-CAP-INTEGRATIONS-GEOFENCE-KEY":
      //         process.env.REACT_APP_GEO_FENCING_KEY,
      //       "X-INTEGRATIONS-RECAPTCHA-TOKEN": result as any,
      //       "X-INTEGRATIONS-RECAPTCHA-ACTION": "FORGOT-PASSWORD",
      //       "DEVICE-TYPE": "webapp",
      //     },
      //   }
      // );

      const status = response.data.status;
      if (status) {
        dispatch(
          resetPasswordEmailActions.ResetPasswordEmail({
            email,
          })
        );
        navigate("/verifyOTP");
      }
    } catch (error: any) {
      if (error?.response?.data?.message) {
        setError(error?.response?.data?.message);
      }
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return { handleLogin, handleResetPasswordClick, error, success, loading };
};

export default useFetchLogin;
